import { render, staticRenderFns } from "./OpenInNewTabIcon.vue?vue&type=template&id=67e24bfc&scoped=true&"
var script = {}
import style0 from "./OpenInNewTabIcon.vue?vue&type=style&index=0&id=67e24bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e24bfc",
  null
  
)

export default component.exports